import React from 'react';
import cn from '@/utils/cn';
import I18n from '@/modules/i18n';
import useGradingStore from '../useGradingStore';

interface StatusProps {
  completedText?: string;
}

const Status = ({ completedText: completedTextProp }: StatusProps) => {
  const assignment = useGradingStore(state => state.assignment);
  const questionAnswers = useGradingStore(state => state.questionAnswers);

  const isInProgress = questionAnswers.length < assignment.questions.length;
  const completedText = completedTextProp || I18n.t('turned_in');

  return (
    <div className="tw-inline-flex tw-items-center tw-gap-1">
      <div
        className={cn(
          'tw-w-3 tw-h-3 tw-rounded-full',
          {
            'tw-bg-[#78A22F]': !isInProgress,
            'tw-bg-[#FCC521]': isInProgress,
          },
        )}
      />
      <span className="-tw-mt-px">{isInProgress ? I18n.t('in_progress') : completedText}</span>
    </div>
  );
};

export default Status;
